/**
 * FlotaApiClient -- las banderas de cada PC (FLOTA-PANEL-VISTA-T1).
 *
 * Contrato A #32359 (nexo-api, sobre v_flota_banderas de 593): GET /api/v1/flota/banderas [RequireAdmin] -> data = {
 * items: [{ businessId, empresa, pcName, huella8, version, vistoAt, interfaz, timer, financiero, tokenPresente }] }.
 * Sin token ni huella completa. La version estable y las publicadas siguen saliendo de /api/v1/version.
 *
 * FAIL-OPEN: sin la ruta devuelve NO_PUBLICADO y la pestana Flota sigue con lo que ya sabe (license/machines); el dia
 * que A la sirva, las banderas aparecen solas.
 *
 * @module infrastructure/api/FlotaApiClient
 */

import { ApiBase } from './ApiBase.js';

export const FlotaApiClient = {
  /** Nunca lanza. @returns {Promise<{ok:boolean, items?:object[], motivo?:string}>} */
  async banderas() {
    let res;
    try {
      res = await ApiBase.get('/api/v1/flota/banderas');
    } catch {
      return { ok: false, motivo: 'SIN_RED' };
    }
    if (res.ok) {
      const d = res.data?.data ?? res.data ?? {};
      return { ok: true, items: Array.isArray(d) ? d : (Array.isArray(d.items) ? d.items : []) };
    }
    const code = String(res.code ?? '');
    if (code === '404') return { ok: false, motivo: 'NO_PUBLICADO' };
    if (code === '403') return { ok: false, motivo: 'PROHIBIDO' };
    return { ok: false, motivo: 'ERROR_API' };
  }
};
